import { html } from "lit";
var icon_facebook_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M23.266 10.768a.542.542 0 00-.4-.185H18.78V9.056c0-.303.065-.65.552-.65h3.25a.477.477 0 00.38-.163.537.537 0 00.151-.368V3.542A.54.54 0 0022.572 3h-4.691c-5.2 0-5.601 4.442-5.601 5.796v1.787H9.573c-.3 0-.542.243-.542.542v4.333c0 .3.242.542.542.542h2.708v12.458c0 .3.242.542.542.542h5.416c.3 0 .542-.243.542-.542V16h3.63a.54.54 0 00.54-.488l.456-4.333a.542.542 0 00-.141-.412z" />
  </svg>
`;
export {
  icon_facebook_default as default
};
//# sourceMappingURL=icon-facebook.js.map
